/*
 * Menu drawer extras (snippets/menu-drawer.liquid, styles in header-layout.css).
 * Now used on every screen size (the file name is from when it was
 * desktop-only).
 *
 * - Places the drawer right under the header's bottom line (top utility bar +
 *   logo row + nav), measured each time it opens and on resize, so the header
 *   stays visible and clickable. Written as --md-top / --md-height.
 * - Esc inside a submenu goes back one level instead of closing the drawer.
 * - Clicking a link closes and resets the drawer before the page changes.
 * - After back/forward navigation the page never shows drawer leftovers
 *   (open state, scroll lock, half-open submenu).
 */
(function () {
  var drawer = document.getElementById('MenuDrawer');
  if (!drawer) return;

  function isOpen() {
    return drawer.hasAttribute('open');
  }

  function place() {
    if (!isOpen()) return;
    var header = drawer.closest('header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    // Where "top: 0" lands for the drawer (the header can be its positioning
    // box when it is transformed), so the offset is right either way.
    drawer.style.setProperty('--md-top', '0px');
    var origin = drawer.getBoundingClientRect().top;
    drawer.style.setProperty('--md-top', Math.round(bottom - origin) + 'px');
    drawer.style.setProperty('--md-height', Math.max(0, Math.round(window.innerHeight - bottom)) + 'px');
  }

  function closeSubmenus() {
    drawer.querySelectorAll('details[is="menu-drawer-details"]').forEach(function (details) {
      details.classList.remove('active');
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
    drawer.querySelectorAll('[data-parent].active').forEach(function (panel) {
      panel.classList.remove('active');
    });
  }

  // Close at once and clear everything the drawer adds to the page.
  function reset() {
    closeSubmenus();
    if (isOpen()) drawer.removeAttribute('open');
    drawer.removeAttribute('active');
    document.body.classList.remove('modal-show', 'modal-showing');
  }

  drawer.addEventListener('toggle', function () {
    if (isOpen()) place();
  });
  window.addEventListener('resize', place);

  drawer.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || link.target === '_blank') return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    reset();
  });

  // Runs before the theme's own Esc handler (which closes the whole drawer).
  window.addEventListener(
    'keyup',
    function (event) {
      if (event.code !== 'Escape' || !isOpen()) return;
      var details = drawer.querySelector('details[is="menu-drawer-details"].active');
      if (!details) return;
      event.stopPropagation();
      details.onCloseButtonClick();
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    },
    true
  );

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) reset();
  });
})();
